import { Module } from 'vuex-smart-module';
import OrganizationActions from './actions';
import OrganizationGetters from './getters';
import OrganizationMutations from './mutations';
import OrganizationState from './state';
import PartnerCompany from './modules/partner-company';
import OrganizationCheck from './modules/organization-check';
import BlackList from './modules/black-list';
import ModelAccreditation from './modules/model-accreditation';

const org_module = new Module({
  state: OrganizationState,
  mutations: OrganizationMutations,
  actions: OrganizationActions,
  getters: OrganizationGetters,
  modules: {
    partner_company: PartnerCompany,
    organization_check: OrganizationCheck,
    black_list: BlackList,
    model_accreditation: ModelAccreditation,
  },
});

export default org_module;
